module.exports = __webpack_public_path__ + "static/section-1-e928212aa4cc7b6a938f08214fe58275.svg";